// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SelectionFieldPopup.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field selection component
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import localizer from 'share/localization/Izenda.Localizer';
import TreeSelectionField from './Izenda.TreeSelectionField';
import actions from './Izenda.SelectionFieldPopupAction';
import connect from 'share/enhancers/Izenda.Connect';
import { head } from 'lodash/fp';

@connect(actions)
export default class SelectionFieldPopup extends Component {
  static propTypes = {
    onAccept: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
    validateAddNewFieldToReportPart: PropTypes.func.isRequired,
    warning: PropTypes.func.isRequired,
    store: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.selectedData = [];
    const filterQuerySource = this.props.store.displayFieldQuerySource;
    const defaultField = head(filterQuerySource[0].fields);

    this.state = {
      selectedQuerySource: filterQuerySource[0],
      selectedField: defaultField
    };
  }

  render() {
    const filterQuerySource = this.props.store.displayFieldQuerySource;
    return (
      <Popup
        visible
        onClosing={this.props.closed}
        type="none"
        autoClose={false}
        containerClass="izenda-SelectionFieldPopup"
      >
        <Popup.Header title={localizer.getText('REPORTDESIGNER_LABEL_FIELD_SELECTION')} />
        <Popup.Body>
          <TreeSelectionField data={filterQuerySource} onChangeData={this.props.onChangeSeletedField} />
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton type="accept">{localizer.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
          <Popup.ConfirmationButton type="cancel">
            {localizer.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.SelectionFieldPopup.js